import type { DeputyParticipation, FundingType, ProjectStatus, ValueType } from '../types/content';

export function formatCurrency(value: number) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: value % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatSummaryCurrency(value: number) {
  const divisor = value >= 1_000_000_000 ? 1_000_000_000 : 1_000_000;
  return value < 1_000_000 ? formatCurrency(value)
    : `${formatCurrency(Math.round(value / divisor * 100) / 100)} ${divisor === 1_000_000 ? 'mi' : 'bi'}`;
}

export const statusLabels: Record<ProjectStatus, string> = {
  concluido: 'Concluído',
  em_execucao: 'Em execução',
  anunciado: 'Anunciado',
  recurso_autorizado: 'Recurso autorizado',
  convenio_firmado: 'Convênio firmado',
  licitacao: 'Licitação em andamento',
  privado_anunciado: 'Investimento privado anunciado',
  privado_implantacao: 'Investimento privado em implantação',
  em_validacao: 'Informação em validação',
};

export const valueLabels: Record<ValueType, string> = {
  recurso_publico: 'Recurso público', investimento_privado: 'Investimento privado',
  obra: 'Valor da obra', convenio: 'Valor do convênio', autorizado: 'Valor autorizado',
  executado: 'Valor executado', em_validacao: 'Classificação em validação',
};

export const participationLabels: Record<DeputyParticipation, string> = {
  indicacao: 'Indicação de recurso', articulacao: 'Articulação institucional',
  apoio: 'Apoio institucional', acompanhamento: 'Acompanhamento',
  anuncio: 'Participação em anúncio', em_validacao: 'Informação em validação',
};

export const categoryLabels = {
  obra_projeto: 'Obras / projetos', equipamento: 'Equipamentos', projeto_futuro: 'Projetos futuros',
};

export const fundingLabels: Record<FundingType, string> = {
  publico: 'Recursos públicos',
  privado: 'Investimento privado',
  contrapartida: 'Recursos estaduais e contrapartida municipal',
  nao_confirmado: 'Origem a confirmar',
};
